/** Auto-generated French UI strings. */
export const MODERATOR_PAGE_MESSAGES_FR: Record<string, string> = {
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.delete': 'Supprimer',
  'common.close': 'Fermer',
  'common.loading': 'Chargement',
  'common.retry': 'Réessayer',
  'common.all': 'Tous',
  'common.previous': 'Retour',
  'common.next': 'Prochaine',
  'common.today': 'Aujourd\'hui',
  'common.tomorrow': 'Demain',
  'common.yesterday': 'Hier',
  'common.subscriber': 'Abonné',
  'common.template': 'Modèle',
  'common.status': 'Statut',
  'common.actions': 'Actions',
  'common.open': 'Ouvrir',
  'common.search': 'Rechercher',
  'common.clearFilters': 'Supprimer les filtres',
  'common.never': 'Jamais',
  'common.justNow': 'A l\'instant',
  'common.minAgo': 'Il y a {n} min',
  'common.hoursAgo': 'Il y a {n} h',
  'common.daysAgo': 'Il y a {n} j',
  'common.unknownTime': 'Temps inconnu',
  'common.secondsAgo': 'Il y a {n} s',
  'common.minutesAgoShort': 'Il y a {n} min',
  'common.hoursAgoShort': 'Il y a {n} h',
  'common.daysAgoShort': 'Il y a {n} j',
  'common.articles': '{count} articles',
  'common.articlesOf': '{shown} sur {total} articles',
  'common.articlesToday': '{count} articles aujourd\'hui',
  'common.optional': '(facultatif)',
  'common.reject': 'Refuser',
  'common.send': 'Envoyer',
  'common.remove': 'Supprimer',
  'common.saved': 'Enregistré',
  'common.dismiss': 'Fermer',
  'common.off': 'Arrêt',
  'common.paused': 'En pause',
  'common.success': 'Réussis',
  'common.failed': 'Échec',
  'common.uncategorized': 'Sans catégorie',
  'common.articleNumber': 'N° D\'ARTICLE{id}',
  'common.create': 'Créer',
  'common.edit': 'editer',
  'common.reset': 'Réinitialiser',
  'common.email': 'Courriel',
  'common.username': 'Identifiant',
  'common.language': 'Langue',
  'common.password': 'Mot de passe',
  'common.saving': 'Enregistrement…',
  'common.creating': 'Création…',
  'common.adding': 'Ajout en cours…',
  'common.removing': 'Suppression…',
  'common.active': 'Actif',
  'common.inactive': 'Inactif',
  'common.system': 'Système',
  'common.custom': 'Personnalisé',
  'common.default': 'Par défaut',
  'common.topics': 'Sujets',
  'common.buzzwords': 'Buzzword',
  'common.keywords': 'Mots-clés',
  'common.preview': 'Aperçu',
  'common.duplicate': 'DUPLIQUER<br>',
  'common.description': 'Description',
  'common.frequency': 'Fréquence',
  'common.timezone': 'Fuseau horaire',
  'common.profile': 'Profil',
  'common.memberSince': 'Membre depuis le',
  'common.daily': 'Tous les jours',
  'common.topic': 'Sujet',
  'common.schedule': 'Calendrier',
  'common.regenerate': 'Regénérer',
  'common.showingRange': 'Affichage{from} à {to}de {total}',
  'emailTemplates.title': 'Modèles d\'e-mail',
  'emailTemplates.subtitle': 'Choisissez, prévisualisez, personnalisez et attribuez des modèles d\'e-mails aux abonnés.',
  'emailTemplates.importTemplate': 'Importer modèle',
  'emailTemplates.newCustomTemplate': 'Nouveau modèle personnalisé',
  'emailTemplates.toastImportSoon': 'La fonctionnalité d\'importation arrive bientôt.',
  'emailTemplates.loadErrorTitle': 'Impossible de charger les modèles à partir de l\'API',
  'emailTemplates.toastLoadTemplates': 'Impossible de charger les modèles d\'e-mail :{msg}',
  'emailTemplates.toastLoadSubscribers': 'Impossible de charger les abonnés :{msg}',
  'emailTemplates.statTotal': 'Nombre total de modèles',
  'emailTemplates.statTotalSub': 'Mes modèles',
  'emailTemplates.statSystem': 'Templates du système',
  'emailTemplates.statSystemSub': 'Fourni par le système',
  'emailTemplates.statCustom': 'Modèles personnalisés',
  'emailTemplates.statCustomSub': 'Créé par vous',
  'emailTemplates.statAssigned': 'Abonnés assignés',
  'emailTemplates.statAssignedSub': 'Avec modèle attribué',
  'emailTemplates.libraryTitle': 'Bibliothèque de Modèles',
  'emailTemplates.searchPlaceholder': 'Rechercher parmi les modèles...',
  'emailTemplates.tab.all': 'Tous',
  'emailTemplates.tab.system': 'Système',
  'emailTemplates.tab.custom': 'Personnalisé',
  'emailTemplates.tab.shared': 'Partagé',
  'emailTemplates.badge.default': 'Par défaut',
  'emailTemplates.badge.shared': '  Partagé  ',
  'emailTemplates.usedByOne': 'Utilisé par{count}Souscripteur',
  'emailTemplates.usedByMany': 'Utilisé par{count} abonnés',
  'emailTemplates.emptyTemplates': 'Aucun template trouvé.',
  'emailTemplates.showingTemplates': 'Article 1 à 15{shown}de {total}Type de modèles',
  'emailTemplates.detailsTitle': 'Détails et aperçu du modèle',
  'emailTemplates.usedByLabel': 'Utilisé par',
  'emailTemplates.subscriberOne': '{count}Souscripteur',
  'emailTemplates.subscriberMany': '{count} abonnés',
  'emailTemplates.lastUpdated': 'Dernière mise à jour',
  'emailTemplates.createdBy': 'Créé par',
  'emailTemplates.createdBySystem': 'Système',
  'emailTemplates.createdByYou': 'pour vous',
  'emailTemplates.actionsTitle': 'Actions',
  'emailTemplates.setAsDefault': 'Définir par défaut',
  'emailTemplates.sendTestEmail': 'Envoyer test mail',
  'emailTemplates.toastDuplicateSoon': 'Fonctionnalité en double bientôt disponible.',
  'emailTemplates.toastTestEmailSoon': 'Fonctionnalité d\'e-mail de test à venir bientôt.',
  'emailTemplates.selectToViewDetails': 'Sélectionnez un modèle pour afficher les détails',
  'emailTemplates.previewTitle': 'Aperçu',
  'emailTemplates.desktop': 'Ordinateur de bureau',
  'emailTemplates.mobile': 'Mobile',
  'emailTemplates.fromLabel': 'De : hawk@digest.io',
  'emailTemplates.viewInBrowser': 'Ouvrir dans le navigateur',
  'emailTemplates.previewDigestLine': '— Votre contenu digest personnalisé',
  'emailTemplates.previewPoweredLine': '— Propulsé par Hawk AI',
  'emailTemplates.moreArticles': '+ plus d\'articles personnalisés pour chaque abonné…',
  'emailTemplates.poweredBy': 'Propulsé par Hawk AI',
  'emailTemplates.selectToPreview': 'Sélectionnez un modèle à prévisualiser',
  'emailTemplates.assignmentsTitle': 'Affectations de modèle d\'abonné',
  'emailTemplates.assignmentsSubtitle': 'Attribuez des modèles aux abonnés. Les abonnés sans affectation utilisent le modèle par défaut.',
  'emailTemplates.searchSubscriber': 'Rechercher abonné',
  'emailTemplates.filterTemplate': 'Modèle',
  'emailTemplates.filterStatus': 'Statut',
  'emailTemplates.statusSaved': 'Enregistré',
  'emailTemplates.statusUnsaved': 'Non enregistré',
  'emailTemplates.bulkAssign': 'Affectation groupée',
  'emailTemplates.toastBulkAssignSoon': 'Affectation groupée bientôt disponible.',
  'emailTemplates.colAssignedTemplate': 'Modèle assigné',
  'emailTemplates.colTemplateType': 'Nom du Modèle',
  'emailTemplates.colLastUpdated': 'Dernière mise à jour',
  'emailTemplates.changeTemplate': 'Changer de modèle',
  'emailTemplates.resetToDefault': 'Réinitialisation par défaut ',
  'emailTemplates.emptySubscribers': 'Aucun abonné trouvé.',
  'emailTemplates.showingSubscribers': 'Article 1 à 15{shown}de {total} abonnés',
  'emailTemplates.dialogNewTitle': 'Nouveau modèle personnalisé',
  'emailTemplates.dialogEditTitle': 'Modifier modèle',
  'emailTemplates.saveChanges': 'Enregistrer les changements',
  'emailTemplates.deleteTitle': 'Supprimer le modèle?',
  'emailTemplates.deleteDesc': 'Supprimer{name}? Les abonnés affectés à ce modèle reviendront à la valeur par défaut. Cela ne peut pas être annulé.',
  'emailTemplates.changeAssignmentTitle': 'Changer d\'affectation de modèle',
  'emailTemplates.changeAssignmentDesc': 'Assigné un template à :{email}',
  'emailTemplates.useDefault': 'Par défaut',
  'emailTemplates.defaultSuffix': '(par défaut)',
  'emailTemplates.toastCreated': 'Modèle créé. Error message',
  'emailTemplates.toastUpdated': 'Template mis à jour.',
  'emailTemplates.toastDefaultUpdated': 'Modèle par défaut mis à jour.',
  'emailTemplates.toastDeleted': 'Modèle supprimé',
  'emailTemplates.toastResetAssignment': 'Restaurer le modèle par défaut',
  'emailTemplates.toastAssignmentUpdated': 'Affectation du modèle mise à jour.',
  'emailTemplates.formName': 'Nom du modèle',
  'emailTemplates.formNamePlaceholder': 'par exemple, My Custom Digest',
  'emailTemplates.formDescriptionPlaceholder': 'Brève description de cette mise en page',
  'emailTemplates.formTag': 'Tag',
  'emailTemplates.formTagPlaceholder': 'par exemple, minimal, technologique, financier',
  'emailTemplates.formAccent': 'Couleur d\'accentuation',
  'emailTemplates.accent.blue': 'Bleu',
  'emailTemplates.accent.amber': 'Ambre',
  'emailTemplates.accent.cyan': 'Cyan',
  'emailTemplates.accent.rose': 'Rose',
  'subscribers.title': 'Souscripteurs',
  'subscribers.subtitle': 'Gérez les destinataires, les calendriers de livraison et les préférences de newsletter.',
  'subscribers.importCsv': 'Importer au format CSV',
  'subscribers.toastImportCsvSoon': 'L\'importation CSV arrive bientôt.',
  'subscribers.addSubscriber': 'Ajouter un abonné',
  'subscribers.statTotal': 'Total Abonnés',
  'subscribers.statTotalSub': 'Tous les destinataires enregistrés',
  'subscribers.statActive': 'Abonnés actifs',
  'subscribers.statActiveSub': 'Prêt à recevoir les newsletters',
  'subscribers.statScheduled': 'Missions planifiées aujourd’hui',
  'subscribers.statScheduledSub': 'Prochain envoi à 06h00 cet',
  'subscribers.statIssues': 'Évaluation du Programme de partenariat syndical-patronal',
  'subscribers.statIssuesSub': 'Ceci nécessite votre attention&#x0D;',
  'subscribers.tableTitle': 'Souscripteurs',
  'subscribers.loadingDirectory': 'Chargement de l’annuaire',
  'subscribers.shownOfTotal': '{filtered}de {total}Affichés',
  'subscribers.searchPlaceholder': 'Rechercher un e-mail ou un nom d\'utilisateur…',
  'subscribers.filterAllLanguages': 'Toutes les langues',
  'subscribers.filterAllTopics': 'Tous les articles',
  'subscribers.filterScheduled': 'Planifié',
  'subscribers.filterNotScheduled': 'Non planifié',
  'subscribers.loading': 'Chargement des abonnés ...',
  'subscribers.colPreferences': 'Preferences',
  'subscribers.colDelivery': 'Livraison',
  'subscribers.colLastSent': 'Dernier envoi',
  'subscribers.topicsLabel': 'Sujets :',
  'subscribers.dailyAt': 'Tous les jours à{time} {tz}',
  'subscribers.emailDigest': 'Recevoir les notifications Digest e-mail',
  'subscribers.lastDeliverySuccess': '• Dernière livraison : Succès',
  'subscribers.notScheduled': 'Non planifié',
  'subscribers.lastDeliveryNa': '• Dernière livraison : N/A',
  'subscribers.importTopicsTitle': 'Importer des sujets et des mots à la mode (.xlsx/.csv)',
  'subscribers.importTopicsAria': 'Importer des sujets et des mots à la mode',
  'subscribers.emptyNone': 'Aucun abonné pour le moment. Ajoutez-en un pour commencer.',
  'subscribers.emptyFilters': 'Aucun abonné ne correspond à vos filtres.',
  'subscribers.showingSubscribers': 'Affichage{from} à {to}de {total} abonnés',
  'subscribers.perPage': '{n}Page',
  'subscribers.sidebarDetails': 'Détails Souscripteur',
  'subscribers.memberSince': 'Membre depuis le',
  'subscribers.topicsSectionTitle': 'Sujets, mots à la mode et mots-clés',
  'subscribers.topicsSectionDesc': 'Mots à la mode pour le contenu de la newsletter. Les mots-clés correspondent aux articles dans le pool de grattoirs.',
  'subscribers.fullEditor': 'Éditeur complet',
  'subscribers.noTopicsHint': 'Aucun sujet pour le moment. Ajoutez un sujet ci-dessous pour attribuer des mots à la mode et des mots-clés.',
  'subscribers.noBuzzwordsYet': 'Pas encore de mots à la mode',
  'subscribers.noKeywordsYet': 'Aucun mot clef',
  'subscribers.addBuzzwordPlaceholder': 'Ajouter un mot à la mode…',
  'subscribers.addKeywordPlaceholder': 'Ajouter un mot-clé',
  'subscribers.addTopic': 'Ajouter un sujet',
  'subscribers.topicNamePlaceholder': 'Nom du topic',
  'subscribers.removeBuzzwordAria': 'Supprimer buzzword{word}',
  'subscribers.removeKeywordAria': 'Retirer le mot-clé{word}',
  'subscribers.deliverySettings': 'Paramètres de livraison',
  'subscribers.sendTime': 'Heure d\'envoi',
  'subscribers.emailTemplate': 'Modèle d\'email',
  'subscribers.defaultDigest': 'Résumé par défaut',
  'subscribers.deliveryHistory': 'Historique des livraisons',
  'subscribers.lastSent': 'Dernier envoi',
  'subscribers.lastStatus': 'Dernier statut',
  'subscribers.lastError': 'Dernière erreur',
  'subscribers.sendTestEmail': 'Envoyer test mail',
  'subscribers.toastTestEmailSoon': 'Fonctionnalité d\'e-mail de test à venir bientôt.',
  'subscribers.pauseSubscriber': 'Suspendre l\'abonné',
  'subscribers.toastPauseSoon': 'La fonction de pause arrive bientôt.',
  'subscribers.deleteSubscriber': 'Supprimer l\'abonné',
  'subscribers.editTitle': 'Modifier le client',
  'subscribers.emailLanguage': 'Langue du courriel',
  'subscribers.newPasswordOptional': 'Mot de passe (facultatif)',
  'subscribers.passwordKeepCurrent': 'Laisser vide pour conserver l\'adresse actuelle',
  'subscribers.passwordMinHint': 'Minimum 8 caractères lorsqu\'il est défini.',
  'subscribers.deleteTitle': 'Supprimer un abonné aux SMS',
  'subscribers.deleteDesc': 'Etes-vous sûr(e) de vouloir supprimer{email}L’opération ne peut pas être annulée.',
  'subscribers.addTitle': 'Ajouter un abonné',
  'subscribers.emailPlaceholder': 'subscriber@example.com',
  'subscribers.usernamePlaceholder': 'identifiant unique',
  'subscribers.passwordPlaceholder': 'Au moins 8 caractères',
  'subscribers.toastImportNothing': 'Rien de nouveau à importer — les sujets et les mots à la mode sont déjà à jour.',
  'subscribers.toastImportSuccess': 'Importation{created}nouveau (x) sujet(s), fusionné (s){merged} ajoutée.{buzz}buzzword(s).',
  'subscribers.toastBuzzwordAdded': 'Buzzword ajouté.',
  'subscribers.toastBuzzwordRemoved': 'Buzzword supprimé.',
  'subscribers.toastKeywordAdded': 'Nouveau mot-clé ajouté',
  'subscribers.toastKeywordRemoved': 'Mot-clé supprimé.',
  'subscribers.toastTopicExists': 'Le sujet existe déjà.',
  'subscribers.toastTopicAdded': 'Sujet ajouté.',
  'subscribers.errEmailUsernameRequired': 'Email et nom d\'utilisateur <br /> Champs obligatoires',
  'subscribers.errPasswordMin': 'Le mot de passe doit comporter au moins 8 caractères.',
  'subscribers.toastUpdated': 'Abonné mis à jour',
  'subscribers.toastRemoved': '%s Abonné supprimé',
  'subscribers.errAllFieldsRequired': 'Le nom d\'utilisateur et le mot de passe sont requis.',
  'subscribers.errPasswordMinCreate': 'Le mot de passe doit comporter au moins 8 caractères.',
  'subscribers.toastAdded': 'Participant ajouté.',
  'subscriberDetail.notFound': 'Abonné introuvable.',
  'subscriberDetail.backToSubscribers': 'Retour aux abonnés',
  'subscriberDetail.regenerate': 'Regénérer',
  'subscriberDetail.sendNow': 'Envoyer maintenant',
  'subscriberDetail.saveChanges': 'Enregistrer les changements',
  'subscriberDetail.allChangesSaved': 'Toutes les modifications sont enregistrées',
  'subscriberDetail.dailySendTime': 'Heure d\'envoi quotidienne',
  'subscriberDetail.emailSentDailyAt': 'E-mail envoyé quotidiennement à{time}',
  'subscriberDetail.emailTemplate': 'Modèle d\'email',
  'subscriberDetail.defaultOption': 'Par défaut{name})',
  'subscriberDetail.usingTemplate': 'Utilisation{name}',
  'subscriberDetail.usingDefault': 'Utilisation par défaut{name}',
  'subscriberDetail.newsletterPreview': 'Aperçu de la newsletter',
  'subscriberDetail.previewIframeTitle': 'Aperçu de la newsletter',
  'subscriberDetail.previewUnavailable': 'Aperçu indisponible',
  'subscriberDetail.topicsBuzzwords': 'Sujets et mots à la mode',
  'subscriberDetail.topicsDesc': 'L\'IA recueille des articles correspondant à ces sujets dans le pool de données et génère un résumé personnalisé.',
  'subscriberDetail.topicCount': '{count}Thème',
  'subscriberDetail.topicCountPlural': '{count} sujets',
  'subscriberDetail.importing': 'Importation…',
  'subscriberDetail.importCsv': 'Importer des sujets et des mots à la mode à partir de CSV / XLSX',
  'subscriberDetail.importFormat': 'Format 2 colonnes :{format}— une ligne par mot à la mode',
  'subscriberDetail.importFormatToken': 'topic, buzzword',
  'subscriberDetail.importDropHint': 'Cliquez pour parcourir ou déposer un fichier .csv / .xlsx',
  'subscriberDetail.deleteTopicTitle': 'Supprimer le sujet',
  'subscriberDetail.noArticlesMatched': 'Aucun article n\'a encore été mis en correspondance',
  'subscriberDetail.noBuzzwordsYet': 'Pas encore de mots à la mode',
  'subscriberDetail.addBuzzwordPlaceholder': 'Ajouter un mot à la mode…',
  'subscriberDetail.addNewTopic': 'Ajouter un nouveau module',
  'subscriberDetail.topicNamePlaceholder': 'Nom du topic',
  'subscriberDetail.aiSummary': 'L\'IA collectera des articles pour{topicCount}et envoyez un résumé personnalisé à{email}Tous les jours à{time} ({timezone}J.-C.).',
  'subscriberDetail.aiSummaryTopicsOne': '{count}Thème',
  'subscriberDetail.aiSummaryTopicsMany': '{count} sujets',
  'subscriberDetail.digestInLanguage': 'Le résumé de l\'IA sera généré dans{language}',
  'subscriberDetail.toastSettingsSaved': 'Paramètres de l\'abonné enregistrés.',
  'subscriberDetail.toastNewsletterSent': 'Newsletter envoyée (ou mise en file d\'attente) en utilisant le projet de pipeline approuvé.',
  'topicMultiSelect.placeholder': 'Sélectionner sujets',
  'topicMultiSelect.empty': 'Aucun sujet pour le moment. Créez d\'abord des sujets dans l\'écran Sujets.',
  'articleAnalysis.noArticle': 'Aucun article sélectionné.',
  'articleAnalysis.backToArticles': 'Retour aux articles',
  'articleAnalysis.networkError': 'Une erreur s\'est produite lors du chargement de cet article.',
  'articleAnalysis.notFound': 'Nous n\'avons pas pu charger cet article. Il se peut qu\'il ait été supprimé ou que le lien soit obsolète.',
  'articleAnalysis.articles': 'Articles',
  'articleAnalysis.title': '<g id="2">Analyse d\'article</g><g id="1"> </g>',
  'articleAnalysis.subtitle': 'Inspectez les balises, le résumé, les URL liées et les entreprises extraites de cet article.',
  'articleAnalysis.dataroomSetting': 'Réglage du dataroom',
  'articleAnalysis.newAnalysis': 'Nouvelle analyse',
  'articleAnalysis.newAnalysisSoon': 'Nouvelle analyse à venir',
  'articleAnalysis.indexed': 'Indexé',
  'articleAnalysis.tags': 'Balises',
  'articleAnalysis.buzzwords': 'Buzzword',
  'articleAnalysis.summary': 'Résumé',
  'articleAnalysis.companies': 'Entreprises',
  'articleAnalysis.noAnalysisYet': 'Pas encore d\'analyse',
  'articleAnalysis.noTags': 'Nous n\'avons pas encore extrait de balises de cet article.',
  'articleAnalysis.noCompanies': 'Nous n\'avons trouvé aucune entreprise mentionnée dans cet article.',
  'articleAnalysis.noUrl': 'Aucune URL',
  'articleAnalysis.noSummary': 'Pas encore d\'analyse.',
  'articleAnalysis.addTag': 'Ajouter une étiquette',
  'articleAnalysis.tagPlaceholder': 'Saisir le nom de l\'étiquette…',
  'articleAnalysis.tagAdded': 'Étiquette ajoutée',
  'articleAnalysis.tagRemoved': 'Étiquette supprimée',
  'articleAnalysis.removeTag': 'Supprimer l\'étiquette',
  'articleAnalysis.tagDuplicate': 'Cette étiquette est déjà sur l\'article.',
  'articleAnalysis.tagEmpty': 'Veuillez saisir un nom d\'étiquette.',
  'articleAnalysis.addCompany': 'Ajouter une entreprise',
  'articleAnalysis.companyPlaceholder': 'Saisir le nom de l\'entreprise…',
  'articleAnalysis.companyAdded': 'Entreprise ajoutée',
  'articleAnalysis.companyDuplicate': 'Cette entreprise est déjà sur l\'article.',
  'articleAnalysis.companyEmpty': 'Veuillez saisir un nom d\'entreprise.',
  'articleAnalysis.articlesHome': 'Articles accueil',
  'dataPool.title': 'Pool de données',
  'dataPool.subtitle': 'Articles collectés auprès de toutes les sources de grattoir',
  'dataPool.searchWithTopic': 'Rechercher des articles',
  'dataPool.searchOrFilter': 'Rechercher des articles ou filtrer par sujet…',
  'dataPool.filterByTopic': 'Filtrer par sujet',
  'dataPool.colTitle': 'Titre',
  'dataPool.colUrl': 'URL de l\'Article',
  'dataPool.colTopic': 'Sujet',
  'dataPool.moreTopics': '+{count} de plus',
  'dataPool.colTime': 'Heure',
  'dataPool.colDataroom': 'DataRoom',
  'dataPool.alreadyInDataroom': 'Déjà dans DataRoom',
  'dataPool.addToDataroom': 'Ajouter à DataRoom',
  'dataPool.addToDataroomTitle': 'Ajouter cet article à DataRoom',
  'dataPool.emptyDate': 'Aucun article collecté à cette date',
  'dataPool.emptyFilters': 'Aucun article ne correspond à vos filtres',
  'dataPool.toastApiKey': 'Clé API du modérateur manquante. Déconnectez-vous et reconnectez-vous en tant que modérateur.',
  'dataPool.toastAdded': 'Ajouté à DataRoom',
  'dataPool.toastNeedAnalysis': 'L\'article doit être analysé avant d\'être ajouté à DataRoom. Ouvrez et exécutez d\'abord l\'analyse.',
  'dataPool.toastNotFound': 'Article introuvable sur le serveur. Actualisez le pool de données et réessayez.',
  'deliveryHistory.title': 'Historique des livraisons',
  'deliveryHistory.subtitle': 'Journal de livraison de la newsletter',
  'deliveryHistory.empty': 'Aucun journal de livraison pour le moment.',
  'deliveryHistory.colSentAt': 'Envoyé le',
  'deliveryHistory.logTitle': 'Journal n°{id}',
  'deliveryHistory.deleteTitle': 'Effacer le journal',
  'deliveryHistory.deleteConfirm': 'Effacer le journal',
  'deliveryHistory.deleteDesc': 'L’opération ne peut pas être annulée.',
  'deliveryHistory.toastLoadFailed': 'Échec du chargement de l\'historique de livraison',
  'deliveryHistory.toastDetailFailed': 'Échec du chargement des détails du journal',
  'deliveryHistory.toastDeleted': 'Journal supprimé',
  'deliveryHistory.toastDeleteFailed': 'Échec de la suppression',
  'draftsOutbox.title': 'Brouillons et boîte d\'envoi',
  'draftsOutbox.subtitle': 'Passez en revue les brouillons de newsletter générés par l\'IA avant de les envoyer',
  'draftsOutbox.tabPending': 'En attente de validation',
  'draftsOutbox.tabAll': 'Tout voir',
  'draftsOutbox.colSubject': 'Sujet',
  'draftsOutbox.colCreated': 'Créée',
  'draftsOutbox.empty': 'Aucun projet trouvé',
  'draftsOutbox.draftTitle': 'Brouillon{id}',
  'draftsOutbox.previewTitle': 'Aperçu du brouillon',
  'draftsOutbox.rejectConfirm': 'Rejeter le brouillon ?',
  'draftsOutbox.rejectDesc': 'Ce brouillon sera marqué comme rejeté et ne sera pas envoyé.',
  'draftsOutbox.loadFailed': 'Échec du chargement du brouillon',
  'draftsOutbox.toastPendingFailed': 'Échec du chargement des brouillons en attente',
  'draftsOutbox.toastLoadFailed': 'Échec du chargement des brouillons',
  'draftsOutbox.toastSent': 'Brouillon envoyé avec succès',
  'draftsOutbox.toastSendFailed': 'Échec lors de l’envoi du rappel d’ébauche',
  'draftsOutbox.toastRejected': 'Brouillon rejeté',
  'draftsOutbox.toastRejectFailed': 'Échec du rejet du brouillon',
  'scraperPool.title': 'Piscine grattoir',
  'scraperPool.subtitle': 'Les sources de votre site Web personnel et votre emploi du temps quotidien',
  'scraperPool.runNow': 'Exécuter le grattoir maintenant',
  'scraperPool.running': 'En cours d\'exécution…',
  'scraperPool.statTotal': 'Nombre total d’URLs',
  'scraperPool.statActive': 'Actif',
  'scraperPool.statArticles': 'Articles dans',
  'scraperPool.addSource': 'Ajouter une Source',
  'scraperPool.addSourceDesc': 'Ajoutez une URL de site Web à votre pool de grattage',
  'scraperPool.domainLabel': 'Domaine ou URL',
  'scraperPool.domainPlaceholder': 'exemple.com',
  'scraperPool.domainHint': 'https :// le préfixe est supprimé automatiquement',
  'scraperPool.addToPool': 'Ajouter au pool',
  'scraperPool.tips': 'Conseils',
  'scraperPool.dailySchedule': 'Horaire quotidien',
  'scraperPool.autoScrapeTime': 'Temps de grattage automatique',
  'scraperPool.runsDaily': 'Fonctionne tous les jours',
  'scraperPool.autoRunsRemaining': 'exécutions auto restantes aujourd\'hui',
  'scraperPool.autoRunsLabel': 'Exécutions auto restantes',
  'scraperPool.autoRunsResetsAt': 'Réinitialisation à {time} chaque jour',
  'scraperPool.autoRunsRemainingOf': '{remaining} sur {total} exécutions auto restantes',
  'scraperPool.autoRunsRemainingHint': 'Exécutions automatiques restantes aujourd\'hui sur la limite quotidienne',
  'scraperPool.loginToSave': 'Connectez-vous pour enregistrer l\'horaire',
  'scraperPool.poolStatus': 'État du pool',
  'scraperPool.poolStatusDesc': 'Aperçu en direct de votre pool de scrapers',
  'scraperPool.statusLabel': 'Statut',
  'scraperPool.statusIdle': 'Inactif',
  'scraperPool.nextRun': 'Prochaine exécution',
  'scraperPool.yourSources': 'Ajouter vos sources',
  'scraperPool.searchPlaceholder': 'Recherche par URL ou sujet…',
  'scraperPool.colUrl': 'URL',
  'scraperPool.colTopics': 'Sujets',
  'scraperPool.colLastRun': 'Dernière exécution',
  'scraperPool.colResult': 'Résultat',
  'scraperPool.colArticles': 'Articles',
  'scraperPool.noArticles': 'Aucun article',
  'scraperPool.unscraped': 'Non raclé',
  'scraperPool.emptySources': 'Aucune source pour le moment. Ajoutez une URL pour commencer à gratter.',
  'scraperPool.emptySearch': 'Aucune source ne correspond à votre recherche.',
  'scraperPool.scraperRunning': 'Grattoir en marche...',
  'scraperPool.removeTitle': 'Supprimer cette source de votre pool de grattoirs ?',
  'scraperPool.removeNote': 'Les articles déjà collectés resteront dans le pool de données.',
  'scraperPool.pageOf': 'Page {page}de {total}',
  'scraperPool.rangeOf': '{from}–{to}de {total}',
  'scraperPool.activePaused': '{active}Actif{paused}En pause',
  'scraperPool.failCount': '{n}Ajourné',
  'scraperPool.toastExists': 'URL déjà dans le pool',
  'scraperPool.toastAdded': 'Source ajoutée au pool',
  'scraperPool.toastRemoved': 'Source retirée du pool',
  'scraperPool.toastAddFailed': 'Échec de l\'ajout de la source',
  'scraperPool.toastRemoveFailed': 'Échec de la suppression de la source',
  'scraperPool.toastUpdateFailed': 'Échec de la mise à jour de la source',
  'scraperPool.toastSaveFailed': 'Impossible de sauvegarder l\'horaire',
  'scraperPool.toastRunFailed': 'Échec de l\'exécution du grattoir',
  'scraperPool.quotaExtraRemaining': 'Exécutions supplémentaires',
  'scraperPool.quotaMaxUrls': 'URL max / exécution',
  'scraperPool.quotaMaxArticles': 'Articles max / URL',
  'scraperPool.quotaLocked': 'Verrouillé par l\'administrateur',
  'scraperPool.quotaLockedMessage': 'Le scraper est désactivé pour ce client. Veuillez contacter l\'administrateur.',
  'scraperPool.quotaNoExtraRuns': 'Aucune exécution supplémentaire disponible pour la période en cours.',
  'scraperPool.quotaMaxUrlLimit': 'Vous pouvez ajouter au maximum {limit} URL par exécution du scraper.',
  'campaigns.strategy.notSaved': 'Pas encore sauvegardé',
  'campaigns.strategy.lastSaved': 'Dernier enregistrement{date}',
  'campaigns.strategy.tzLondon': '(UTC+00:00) Londres, Royaume-Uni',
  'campaigns.strategy.tzBerlin': '(UTC+01:00) Berlin, Allemagne',
  'campaigns.strategy.tzHcm': '(GMT+7) Hô Chi Minh-Ville, Vietnam',
  'campaigns.strategy.tzParis': '(UTC+01:00) Paris, France',
  'campaigns.strategy.catSaas': 'La technologie SaaS',
  'campaigns.strategy.catB2b': 'Marketing B2B',
  'campaigns.strategy.catFintech': 'Fintech',
  'campaigns.strategy.catHealthcare': 'Santé',
  'campaigns.strategy.errObjectiveRequired': 'L\'objectif est requis.',
  'campaigns.strategy.errAudienceRequired': 'Le public cible est requis.',
  'campaigns.strategy.errBrandRequired': 'Des directives de marque sont requises.',
  'campaigns.strategy.errFrequencyRequired': 'La fréquence de publication est requise.',
  'campaigns.strategy.errMaxChars': 'Maximum{n} caractères.',
  'campaigns.strategy.errAddOne': 'Ajouter au moins un lien{item}.',
  'campaigns.strategy.errMaxItems': 'Maximum{n} {item}éléments.',
  'campaigns.strategy.errItemMaxLen': 'Pour chaque{item}être abordée à{n}caractères ou moins.',
  'campaigns.strategy.itemTone': 'ton/tonalité/le son / son /intonation/ timbre /raffermir/se raffermir/s\'harmoniser',
  'campaigns.strategy.itemPillar': 'pilier',
  'campaigns.strategy.itemMessage': 'message',
  'campaigns.strategy.itemHashtag': 'hashtag',
  'campaigns.strategy.itemTime': 'convenu',
  'campaigns.strategy.itemCompetitor': 'compétiteur/concurrent',
  'campaigns.strategy.previewBrand': 'Positionnement de la marque{text}',
  'campaigns.strategy.previewPillars': 'Piliers de contenu {text}',
  'campaigns.strategy.previewTone': 'Ton de voix :{text}',
  'campaigns.strategy.previewMessages': 'Messages clés&#160;:{text}',
  'campaigns.strategy.previewHashtags': 'Plan de hashtag :{text}',
  'linkedInSchedule.title': 'Calendrier LinkedIn',
  'linkedInSchedule.subtitle': 'Planifiez, organisez et automatisez les publications de campagne au cours des prochaines dates.',
  'linkedInSchedule.autoSchedule': 'Planifier automatiquement',
  'linkedInSchedule.newCampaign': 'Nouvelle campagne',
  'linkedInSchedule.newPost': 'Nouvel Article',
  'linkedInSchedule.allCampaigns': 'Toutes les campagnes ',
  'linkedInSchedule.allStatus': 'Tous les statuts',
  'linkedInSchedule.allLanguages': 'Toutes les langues',
  'linkedInSchedule.searchPlaceholder': 'Rechercher des publications, des titres ou des campagnes…',
  'linkedInSchedule.prevDays': 'Jours précédents',
  'linkedInSchedule.nextDays': 'Prochains jours',
  'linkedInSchedule.statTotalScheduled': 'Total des publications planifiées',
  'linkedInSchedule.statDraftsPending': 'Brouillons en attente d\'approbation',
  'linkedInSchedule.statActiveCampaigns': 'Campagnes actives',
  'linkedInSchedule.statUpcomingAutoPosts': 'Publications automatiques à venir',
  'linkedInSchedule.statPostingFrequency': 'Fréquence de publication',
  'linkedInSchedule.statGrowth': '+12% vs 7 derniers jours',
  'linkedInSchedule.statNeedsReview': 'Nécessite une révision@option: check trans-unit state',
  'linkedInSchedule.statRunningPaused': '{active}Exécuter{paused}En pause',
  'linkedInSchedule.statNextPost': 'Today, 11:45 AM',
  'linkedInSchedule.statFrequencyValue': '4.2. les postes',
  'linkedInSchedule.statOptimal': 'Optimal',
  'linkedInSchedule.gridCampaigns': 'Campagnes',
  'linkedInSchedule.postsProgress': '{approved} / {total} Commentaires',
  'linkedInSchedule.dragHint': 'Faites glisser et déposez les publications pour les reprogrammer',
  'linkedInSchedule.viewMonth': 'Mois',
  'linkedInSchedule.viewWeek': 'Semaine',
  'linkedInSchedule.viewList': 'Liste',
  'linkedInSchedule.draft': 'Projet',
  'linkedInSchedule.postDetails': 'Détails de l\'Article',
  'linkedInSchedule.dayDetails': '{day} Informations',
  'linkedInSchedule.postTitle': 'Post Title',
  'linkedInSchedule.language': 'Langue',
  'linkedInSchedule.scheduledDateTime': 'Date/Heure planifiée',
  'linkedInSchedule.campaign': 'Campagne',
  'linkedInSchedule.objectiveCta': 'Objectif / CTA',
  'linkedInSchedule.approval': 'Approbation',
  'linkedInSchedule.schedule': 'Calendrier',
  'linkedInSchedule.publishNow': 'Publier Maintenant',
  'linkedInSchedule.saveDraft': 'Enregistrer en brouillon',
  'linkedInSchedule.deletePost': 'Supprimer',
  'linkedInSchedule.storedPosts': 'Publications enregistrées',
  'linkedInSchedule.draftEmpty': 'Faites glisser les publications ici pour les stocker dans le brouillon.',
  'linkedInSchedule.dayPostsCount': '{count}publication(s) sur{day}',
  'linkedInSchedule.noPostsDay': 'Aucune publication planifiée pour ce jour.',
  'linkedInSchedule.hoverLocation': 'Emplacement',
  'linkedInSchedule.hoverRole': 'Rôle',
  'linkedInSchedule.hoverTime': 'Heure',
  'linkedInSchedule.hoverDate': 'Date',
  'linkedInSchedule.scheduleConflict': 'Conflit d\'horaire en ce moment',
  'linkedInSchedule.linkedInAccount': 'Compte Linkedin',
  'linkedInSchedule.removeFromDraft': 'Supprimer{title}à partir du brouillon',
  'linkedInSchedule.datePickerTitle': 'Sélecteur de plage de durée',
  'linkedInSchedule.chooseStartDate': 'Choisissez une date de début',
  'linkedInSchedule.chooseEndDate': 'Choisissez une date de départ',
  'linkedInSchedule.closeDatePicker': 'Fermer le sélecteur de plage de dates',
  'linkedInSchedule.prevMonth': 'Mois précédent',
  'linkedInSchedule.nextMonth': 'Mois suivant',
  'linkedInSchedule.startDate': 'Date début',
  'linkedInSchedule.endDate': 'Date de fin',
  'linkedInSchedule.clearDates': 'Réinitialiser',
  'linkedInSchedule.saveDates': 'DATES À RETENIR',
  'linkedInSchedule.approval.approved': 'Approuvé',
  'linkedInSchedule.approval.pending': 'En attente',
  'linkedInSchedule.approval.rejected': 'Rejeté',
  'campaigns.tab.overview': 'Présentation',
  'campaigns.tab.content': 'Contenu',
  'campaigns.tab.strategy': 'Stratégie',
  'campaigns.tab.schedule': 'Calendrier',
  'campaigns.tab.analytics': 'Analytique',
  'campaigns.tab.settings': 'Réglages',
  'campaigns.title': 'LinkedIn',
  'campaigns.newLinkedIn': 'Nouveau LinkedIn',
  'campaigns.searchPlaceholder': 'Chasse sur LinkedIn',
  'campaigns.allStatus': 'Tous les statuts',
  'campaigns.campaignCount': '{count}CAMPAGNE(S)',
  'campaigns.status.active': 'Actif',
  'campaigns.status.completed': 'Terminé',
  'campaigns.preview': 'Aperçu',
  'campaigns.edit': 'editer',
  'campaigns.createdOn': 'Créer le {date}',
  'campaigns.type.awareness': 'Notoriété',
  'campaigns.type.productLaunch': 'Lancement produit',
  'campaigns.type.engagement': 'Engagement',
  'campaigns.type.content': 'Contenu',
  'campaigns.type.event': 'Événement',
  'campaigns.type.recruitment': 'Recrutement',
  'campaigns.type.thoughtLeadership': 'Leadership d\'opinion',
  'campaigns.contentReview': 'Révision du contenu',
  'campaigns.contentReviewDesc': 'Passez en revue et approuvez votre contenu avant de le programmer',
  'campaigns.language': 'Langue',
  'campaigns.posts': 'Articles',
  'campaigns.postsInCampaign': '{count}dans cette campagne,',
  'campaigns.addNewPost': 'Ajouter un Nouvel Article',
  'campaigns.postTitle': 'Post Title',
  'campaigns.content': 'Contenu',
  'campaigns.media': 'Médias',
  'campaigns.noImages': 'Aucune image',
  'campaigns.imageCount': '{count}Image(s)',
  'campaigns.uploadedMedia': 'Médias téléchargés',
  'campaigns.callToAction': 'Appel à Action',
  'campaigns.cta.learnMore': 'En savoir plus',
  'campaigns.cta.signUp': 'Inscription',
  'campaigns.cta.contact': 'Nous joindre',
  'campaigns.cta.download': 'Télécharger',
  'campaigns.saveDraft': 'Enregistrer en brouillon',
  'campaigns.approveSchedule': 'Approuver et planifier',
  'campaigns.noPostSelected': 'Aucun poste n\'a été sélectionné.',
  'campaigns.addFirstPost': 'Cliquez sur « Ajouter une nouvelle publication » pour créer votre première publication',
  'campaigns.comingSoon': 'Cette section arrive bientôt',
  'campaigns.aiStrategyAssistant': 'Assistante Stratégie IA',
  'campaigns.aiContentAssistant': 'Assistant de contenu AI',
  'campaigns.newChat': 'Nouvelle discussion',
  'campaigns.strategyOverview': 'Présentation de la stratégie',
  'campaigns.strategyOverviewDesc': 'Définissez la stratégie de contenu pour votre campagne LinkedIn. Cette stratégie sera utilisée comme contexte pour la génération de contenu d\'IA.',
  'campaigns.fixRequired': 'Champs obligatoires',
  'campaigns.unsavedChanges': 'Modifications non enregistrées',
  'campaigns.objective': 'Objectif de la campagne',
  'campaigns.targetAudience': 'Public cible',
  'campaigns.category': 'Catégorie',
  'campaigns.toneOfVoice': 'Ton de la voix',
  'campaigns.tonePlaceholder': 'Ajouter une tonalité (par exemple, Professionnel)',
  'campaigns.toneNotesPlaceholder': 'Notes tonales facultatives...',
  'campaigns.brandGuidelines': 'Recommandations relatives à l\'image de marque',
  'campaigns.competitorPlaceholder': 'Ajouter un concurrent',
  'campaigns.contentPillars': 'Piliers de contenu ',
  'campaigns.addPillar': '﻿Ajouter une nouvelle colonne',
  'campaigns.keyMessages': 'MESSAGES  CLÉS',
  'campaigns.addMessage': 'Ajouter message',
  'campaigns.hashtagStrategy': 'Stratégie de hashtag',
  'campaigns.hashtagPlaceholder': 'Ajouter un nouvel hashtag',
  'campaigns.hashtagNotesPlaceholder': 'Notes d\'utilisation du hashtag…',
  'campaigns.postingFrequency': 'Fréquence de publication',
  'campaigns.preferredPostingTime': 'Heure de publication préférée',
  'campaigns.strategyDirtyHint': 'Économisez pour appliquer une stratégie pour la génération d\'IA par poste.',
  'campaigns.strategySynced': 'La stratégie est synchronisée avec la dernière sauvegarde.',
  'campaigns.generating': 'Génération en cours',
  'campaigns.generateStrategyAi': 'Générer une stratégie avec l\'IA',
  'campaigns.saveStrategy': 'Enregistrer la stratégie',
  'campaigns.resetChanges': 'Rétablir les modifications',
  'campaigns.saving': 'Enregistrement…',
  'campaigns.generateStrategy': 'Générer une stratégie',
  'campaigns.suggestPillars': 'Suggérer des piliers de contenu',
  'campaigns.suggestPillarsDesc': 'Obtenez des suggestions d\'IA pour les piliers de contenu en fonction de votre objectif.',
  'campaigns.suggestMessages': 'Suggérer des messages clés',
  'campaigns.suggestMessagesDesc': 'Générez des messages clés qui trouvent un écho auprès de votre public.',
  'campaigns.suggestHashtags': 'Suggérer des hashtags',
  'campaigns.suggestHashtagsDesc': 'Trouvez des hashtags pertinents pour une meilleure portée et un meilleur engagement.',
  'campaigns.suggestTimes': 'Suggérer des heures de publication',
  'campaigns.suggestTimesDesc': 'Obtenez des temps de publication optimaux en fonction de votre public.',
  'campaigns.askAnything': 'Demande-moi n\'importe quoi !',
  'campaigns.addChip': 'Ajouter une puce',
  'campaigns.addListItem': 'Ajout liste objet',
  'campaigns.addItem': 'Ajouter un élément',
  'campaigns.toastStrategySaved': 'Stratégie enregistrée. Les nouveaux articles utiliseront ce contexte pour la génération d\'IA par article.',
  'campaigns.scheduleTitle': 'Calendrier LinkedIn',
  'campaigns.scheduleSubtitle': 'Faites glisser et déposez les publications pour planifier ou reprogrammer',
  'campaigns.prevWeek': 'Semaine précédente',
  'campaigns.nextWeek': 'Semaine suivante',
  'campaigns.showUnscheduled': 'Afficher les dates non programmées',
  'campaigns.allDay': 'Toute la journée',
  'campaigns.conflict': 'Conflits',
  'campaigns.postsOnCalendar': '{name}—{count}publications sur un seul calendrier',
  'campaigns.scheduledUnscheduled': '{scheduled}Planifié{unscheduled}Non planifié',
  'campaigns.draggingPost': 'Glisser la publication…',
  'campaigns.schedulingConflicts': '{count}%s conflit(s) d\'horaire',
  'campaigns.scheduleRules': 'Règles de planification',
  'campaigns.scheduleRulesDesc': 'Max.{maxPerDay}posts/jour · min{minHours}h à part · les publications affichées ne peuvent pas bouger. Cliquez sur une publication pour l\'ouvrir dans le contenu.',
  'campaigns.unscheduledPosts': 'Afficher les articles non planifiés',
  'campaigns.dropToUnschedule': 'Déposez ici pour annuler la planification',
  'campaigns.noUnscheduledPosts': 'Aucune publication non planifiée',
  'campaigns.errPostedCannotReschedule': 'Les articles publiés ne peuvent pas être reprogrammés',
  'campaigns.overview.campaignStatus': 'État de la campagne',
  'campaigns.overview.objective': 'Objectif',
  'campaigns.overview.targetAudience': 'Public cible',
  'campaigns.overview.category': 'Catégorie',
  'campaigns.overview.owner': 'Responsable',
  'campaigns.overview.postStatusSummary': 'synthèse d\'état',
  'campaigns.overview.campaignProgress': 'Progression Campagne',
  'campaigns.overview.schedulePreview': 'Aperçu de l\'horaire',
  'campaigns.overview.strategySnapshot': 'Aperçu de la stratégie',
  'campaigns.overview.topHashtags': 'Top Hashtags',
  'campaigns.overview.analyticsSnapshot': 'Instantané analytique',
  'campaigns.overview.lastUpdated': 'Dernière mise à jour :{date}',
  'campaigns.overview.recentActivity': 'Activité récente',
  'campaigns.overview.viewProgress': 'Afficher les détails de la progression +',
  'campaigns.overview.viewSchedule': 'Cliquez-ici pour avoir accès à la liste complète des programmes de formation.',
  'campaigns.overview.viewStrategy': 'Voir la stratégie +',
  'campaigns.overview.viewAnalytics': 'Voir Analytics',
  'campaigns.overview.viewActivity': 'Voir toute l\'activité +',
  'campaigns.overview.openSchedule': 'Calendrier complet',
  'campaigns.overview.impressions': 'Vues',
  'campaigns.overview.clicks': 'Clics',
  'campaigns.overview.reactions': 'Réactions',
  'campaigns.overview.comments': 'Commentaires',
  'campaigns.overview.shares': 'Partages',
  'campaigns.overview.engagementRate': 'Taux Engagement',
  'campaigns.overview.archived': 'Archivé',
  'campaigns.overview.nextPost': 'Publication suivante',
  'campaigns.overview.following': 'Suivi',
  'campaigns.overview.viewAllPosts': 'Voir tous les articles +',
  'campaigns.overview.totalPosts': 'articles au total',
  'campaigns.overview.completionRate': 'Taux d\'achèvement',
  'campaigns.overview.totalPostsLabel': 'Total des articles',
  'campaigns.overview.members': '{count} membres',
  'campaigns.overview.moreHashtags': '+{count} de plus',
  'campaigns.overview.daysRemaining': '{count} jours restants',
  'campaigns.overview.activity.postApproved': 'Publication {post} approuvée',
  'campaigns.overview.activity.postScheduled': 'Publication {post} planifiée',
  'campaigns.overview.activity.postPublished': 'Publication {post} publiée',
  'campaigns.overview.activity.aiApplied': 'Suggestions IA appliquées à la publication {post}',
  'campaigns.overview.activity.settingsUpdated': 'Paramètres de campagne mis à jour',
  'campaigns.settings.general': 'Paramètres généraux',
  'campaigns.settings.generalDesc': 'Gérez les informations de base et les préférences par défaut pour cette campagne.',
  'campaigns.settings.campaignName': 'Nom de la Campagne',
  'campaigns.settings.defaultLanguage': 'Langue par default',
  'campaigns.settings.timeZone': 'Fuseau horaire',
  'campaigns.settings.approval': 'Flux de travail d’approbation',
  'campaigns.settings.approvalDesc': 'Configurez qui peut examiner et approuver le contenu avant de le publier.',
  'campaigns.settings.reviewers': 'Réviseurs',
  'campaigns.settings.approvers': 'Approbateurs',
  'campaigns.settings.autoApproveDrafts': 'Approuver automatiquement les brouillons',
  'campaigns.settings.reminder': 'Rappel',
  'campaigns.settings.approvalNote': 'Le projet de contenu devra être approuvé manuellement.',
  'campaigns.settings.notifications': 'Notifications',
  'campaigns.settings.notificationsDesc': 'Choisissez les mises à jour que vous souhaitez recevoir.',
  'campaigns.settings.notifyApproval': 'Demandes d\'approbation de contenu',
  'campaigns.settings.notifyReminders': 'Rappels de publication planifiée',
  'campaigns.settings.notifyPerformance': 'Publier des alertes de performance',
  'campaigns.settings.notifyStatus': 'Changements de statut de la campagne',
  'campaigns.settings.integrations': 'Intégrations',
  'campaigns.settings.integrationsDesc': 'Connectez des outils et des services externes.',
  'campaigns.settings.connected': 'Connecté',
  'campaigns.settings.manage': 'Gérer',
  'campaigns.settings.privacy': 'Confidentialité des données',
  'campaigns.settings.privacyDesc': 'Gérer la conservation des données et les préférences de confidentialité.',
  'campaigns.settings.dataRetention': 'Conservation des données',
  'campaigns.settings.anonymize': 'Anonymiser les données analytiques',
  'campaigns.settings.anonymizeDesc': 'Supprimer les informations personnellement identifiables.',
  'campaigns.settings.dangerZone': 'Zone dangereuse',
  'campaigns.settings.dangerDesc': 'Actions irréversibles et sensibles.',
  'campaigns.settings.archiveCampaign': 'Archiver la campagne',
  'campaigns.settings.archiveDesc': 'Cela archivera la campagne et tout le contenu associé.',
  'campaigns.settings.archive': 'Archive',
  'campaigns.settings.deleteCampaign': 'Supprimer la campagne',
  'campaigns.settings.deleteDesc': 'Cette action est irréversible. Toutes les données seront définitivement supprimées.',
  'campaigns.settings.saveChanges': 'Enregistrer les modifications',
  'campaigns.settings.saving': 'Enregistrement…',
  'campaigns.datePicker.chooseStart': 'Choisissez une date de début',
  'campaigns.datePicker.chooseEnd': 'Choisissez une date de départ',
  'campaigns.datePicker.reference': 'Référence de l\'horaire LinkedIn',
  'campaigns.datePicker.close': 'Fermer le sélecteur de plage de dates',
  'campaigns.datePicker.prevMonth': 'Mois précédent',
  'campaigns.datePicker.nextMonth': 'Mois suivant',
  'linkedInSchedule.status.scheduled': 'Planifié',
  'linkedInSchedule.status.draft': 'Projet',
  'linkedInSchedule.status.approved': 'Approuvé',
  'linkedInSchedule.status.posted': 'Posté',
  'dataroom.selectedArticles': 'Articles sélectionnés{count})',
  'dataroom.selectionHint': 'Cliquez sur un article dans DataRoom pour le sélectionner, ou faites-le glisser et déposez-le ici.',
  'dataroom.noArticlesSelected': 'Aucun article sélectionné',
  'dataroom.deselectArticle': 'Désélectionner l\'article',
  'dataroom.breadcrumbDataRooms': 'DataRooms',
  'dataroom.pageTitle': 'Réglage du dataroom',
  'dataroom.libraryAriaLabel': 'Articles Dataroom',
  'dataroom.deliveryPublishingTitle': 'Livraison et édition',
  'dataroom.deliveryPublishingSubtitle': 'Configurez la façon dont ce résumé DataRoom sera généré, examiné et livré.',
  'dataroom.dataroomTitle': 'DataRoom',
  'dataroom.savedArticles': '{count}article enregistré',
  'dataroom.savedArticlesPlural': '{count}Articles enregistrés',
  'dataroom.searchDataroom': 'Rechercher une DataRoom...',
  'dataroom.searchNoResults': 'Aucun article ne correspond à votre recherche.',
  'dataroom.collectedTopicsAria': 'Sujets collectés',
  'dataroom.noTopicsYet': 'Aucun sujet',
  'dataroom.collectedArticlesEmpty': 'Les articles collectés apparaîtront ici.',
  'dataroom.removeArticleFromDataroom': 'Supprimer{title}de DataRoom',
  'dataroom.general': 'Général',
  'dataroom.sendNow': 'Synchroniser maintenant',
  'dataroom.scheduleSend': 'Planifier l’envoi',
  'dataroom.exportFile': 'Exporter sous forme de fichier',
  'dataroom.sendNowDesc': 'Générez et envoyez le résumé immédiatement.',
  'dataroom.scheduleSendDesc': 'Envoyez une ou plusieurs fois à un moment configuré.',
  'dataroom.exportFileDesc': 'Téléchargez le résumé au format PDF, DOCX ou CSV.',
  'dataroom.deliveryMethodAria': 'Mode de livraison',
  'dataroom.saveDraft': 'Enregistrer en brouillon',
  'dataroom.sendEmailNow': 'Envoyer l\'email maintenant',
  'dataroom.downloadFile': 'Télécharger le fichier',
  'dataroom.working': 'En cours...',
  'dataroom.configuration': 'Configuration',
  'dataroom.recipients': 'Destinataires',
  'dataroom.recipientsSelected': '{count}Aucun destinataire sélectionné',
  'dataroom.recipientsSelectedPlural': '{count}destinataires sélectionnés',
  'dataroom.searchSubscriberPlaceholder': 'Rechercher par nom ou courriel',
  'dataroom.searchByNameOrEmail': 'Rechercher par nom ou courriel',
  'dataroom.selectAll': 'Sélectionner tout',
  'dataroom.clear': 'Réinitialiser',
  'dataroom.loadingSubscribers': 'Chargement des abonnés ...',
  'dataroom.noSubscribersFound': 'Aucun abonné trouvé.',
  'dataroom.selectedRecipients': 'Destinataires choisis{count})',
  'dataroom.removeRecipient': 'Supprimer{email}',
  'dataroom.emailSubject': 'Objet du mail',
  'dataroom.sendNowInfo': 'Ce résumé sera envoyé immédiatement après avoir examiné l\'aperçu et cliqué sur Envoyer un e-mail maintenant.',
  'dataroom.scheduleType': 'Type de planning',
  'dataroom.oneTime': 'Ponctuelle',
  'dataroom.recurring': 'Répétitive',
  'dataroom.date': 'Date',
  'dataroom.time': 'Heure',
  'dataroom.timezone': 'Fuseau horaire',
  'dataroom.recurringInfo': 'Les horaires récurrents se répètent tous les jours à l\'heure sélectionnée (tâche récurrente principale).',
  'dataroom.exportFormat': 'Format d’exportation',
  'dataroom.fileContent': 'Contenu du fichier',
  'dataroom.includeArticleSummary': 'Inclure le résumé de l\'article',
  'dataroom.includeSourceLinks': 'Inclure les liens source',
  'dataroom.includeTopicGrouping': 'Inclure le regroupement des sujets',
  'dataroom.includeRawUrlsOnly': 'Inclure uniquement les URL d\'article brutes',
  'dataroom.fileName': 'Nom de fichier',
  'dataroom.previewValidation': 'Aperçu et validation',
  'dataroom.generate': 'Générer',
  'dataroom.generating': 'Génération en cours',
  'dataroom.previewGenerated': 'Aperçu généré',
  'dataroom.regenerate': 'Regénérer',
  'dataroom.regenerating': 'Régénération en cours…',
  'dataroom.generatingPreviewAi': 'Génération de l\'aperçu avec l\'IA…',
  'dataroom.regeneratingPreview': 'Régénération de l\'aperçu…',
  'dataroom.generatedAt': 'Généré à',
  'dataroom.articlesIncluded': 'Articles inclus?',
  'dataroom.articlesCount': '{count} articles',
  'dataroom.topics': 'Sujets',
  'dataroom.recipientsCount': '{count}Destinataires',
  'dataroom.reviewBeforeSend': 'Veuillez consulter l\'aperçu avant de l\'envoyer.',
  'dataroom.subject': 'Sujet',
  'dataroom.openFullPreview': 'Aperçu complet',
  'dataroom.fullPreviewAria': 'Aperçu complet',
  'dataroom.previewDeviceSizeAria': 'Prévisualiser la taille de l\'appareil',
  'dataroom.fullDigestPreview': 'Aperçu complet du résumé -{device}',
  'dataroom.selectDate': 'Sélectionner une date',
  'dataroom.selectTime': 'Sélectionner une heure',
  'dataroom.previousMonth': 'Mois précédent',
  'dataroom.nextMonth': 'Mois suivant',
  'dataroom.weekdaySu': 'Di',
  'dataroom.weekdayMo': 'Mo',
  'dataroom.weekdayTu': 'Ma',
  'dataroom.weekdayWe': 'Nous',
  'dataroom.weekdayTh': 'Th',
  'dataroom.weekdayFr': 'Fr',
  'dataroom.weekdaySa': 'Sa',
  'dataroom.hour': 'Heure',
  'dataroom.minute': 'Minute',
  'dataroom.now': 'Aujourd\'hui •',
  'dataroom.am': 'Le matin',
  'dataroom.pm': 'L\'apres-midi',
  'dataroom.deviceIphone': 'iPhone',
  'dataroom.deviceAndroid': 'Android',
  'dataroom.devicePc': 'CP',
  'dataroom.assistantAriaLabel': 'Assistant de contenu IA',
  'dataroom.aiContentAssistant': 'Assistant de contenu AI',
  'dataroom.newChat': 'Nouvelle discussion',
  'dataroom.thinking': 'Réflexion ',
  'dataroom.messagePlaceholder': 'Tapez votre message…',
  'dataroom.messageAriaLabel': 'Message de l\'assistant IA',
  'dataroom.sendMessageAria': 'Envoyer le message',
  'dataroom.assistantWelcome': 'Bonjour ! Faites glisser des articles de la DataRoom dans ce chat pour les importer comme documents, puis posez vos questions. Vous pouvez aussi demander la configuration d\'envoi ou l\'état de l\'aperçu.',
  'dataroom.assistantRequestFailed': 'La requête a échoué. Veuillez réessayer.',
  'dataroom.assistantNoArticles': 'Ajoutez au moins un article dans la DataRoom avant de demander de l\'aide à l\'assistant.',
  'dataroom.assistantDropHint': 'Faites glisser un article DataRoom ici pour l\'importer dans ce chat.',
  'dataroom.assistantAttachedAria': 'Articles importés dans ce chat',
  'dataroom.assistantImporting': 'Import de l\'article…',
  'dataroom.assistantImportedArticle': '« {title} » importé ({chunks} chunks). Posez-moi vos questions.',
  'dataroom.assistantImportSuccess': '« {title} » a été importé dans le chat.',
  'dataroom.assistantImportFailed': 'Impossible d\'importer l\'article dans le chat.',
  'dataroom.assistantAlreadyImported': '« {title} » est déjà importé dans ce chat.',
  'dataroom.assistantDropUnknownArticle': 'Cet article n\'est plus dans la DataRoom.',
  'dataroom.validationNoArticles': 'Ajoutez au moins un article à la DataRoom avant de générer un aperçu.',
  'dataroom.validationNoSelected': 'Sélectionnez ou faites glisser au moins un article dans Aperçu et validation.',
  'dataroom.validationGeneratePreview': 'Générez un aperçu avant d\'envoyer, de planifier ou d\'exporter.',
  'dataroom.validationScheduleDateTime': 'Choisissez une date et une heure de planification avant de planifier.',
  'dataroom.defaultEmailSubject': 'Daily HAWK Digest -{date}',
  'dataroom.toastSelectRecipient': 'Vous devez sélectionner au moins un destinataire. ',
  'dataroom.toastSelectArticle': 'Sélectionnez au moins un article à livrer.',
  'dataroom.toastGeneratePreview': 'Générez un aperçu avant l\'envoi.',
  'dataroom.toastGenerateBeforeSchedule': 'Générez un aperçu avant de planifier.',
  'dataroom.toastApiKeyMissing': 'Clé API du modérateur manquante. Déconnectez-vous et reconnectez-vous en tant que modérateur.',
  'dataroom.toastStaleArticlesRemoved': '{count}article(s) obsolète (s) supprimé (s) de DataRoom ({titles}). Ré-adjoignez-les à partir du pool de données.',
  'dataroom.toastSentSuccess': 'Envoyé à{count}Souscripteur',
  'dataroom.toastSentSuccessPlural': 'Envoyé à{count} abonnés',
  'dataroom.toastSentPartial': 'Envoyé à{success}, a échoué pour{failed}significative.{error}',
  'dataroom.toastSendFailed': 'Echec. Veuillez essayer à nouveau.',
  'dataroom.toastChooseSchedule': 'Choisissez une date et une heure planifiées.',
  'dataroom.toastScheduledSuccess': 'Planifié pour{count}Souscripteur',
  'dataroom.toastScheduledSuccessPlural': 'Planifié pour{count} abonnés',
  'dataroom.toastScheduledPartial': 'Planifié pour{success}, a échoué pour{failed}significative.{error}',
  'dataroom.toastScheduleFailed': 'Echec. Veuillez essayer à nouveau.',
  'dataroom.toastCsvDownloaded': 'Fichier CSV téléchargé.',
  'dataroom.toastPdfPrint': 'Boîte de dialogue d\'impression ouverte pour l\'exportation PDF.',
  'dataroom.toastDocDownloaded': 'Document téléchargé (HTML-based .doc).',
  'dataroom.toastExportFailed': 'Echec. Veuillez essayer à nouveau.',
  'dataroom.toastDraftSaved': 'Paramètres de livraison enregistrés comme brouillon.',
  'dataroom.toastDraftSaveFailed': 'Impossible d’enregistrer le brouillon',
  'dataroom.errGenerationFailed': 'La génération du rapport a échoué. Veuillez réessayer.',
  'dataroom.errStaleArticles': '{count}article(s) ne sont plus sur le serveur ({titles}). Ils ont été supprimés — ajoutez à nouveau à partir du pool de données, puis générez à nouveau un aperçu.',
  'dataroom.errNoValidArticles': 'Aucun article valide à envoyer. Ré-adjoindre des articles à partir du pool de données.',
  'dataroom.errArticleNotAnalyzed': '&gt;&gt;&gt;{title}» n\'a pas encore été analysé. Exécuter l\'analyse dans le pool de données avant l\'envoi.',
  'dataroom.errSyncArticle': 'Impossible de synchroniser "{title} "ID",{id}):{reason}',
  'dataroom.errDispatchNoHistory': 'L\'expédition n\'a pas renvoyé d\'identifiant d\'historique.',
  'dataroom.errEmailDeliveryFailed': 'Échec de la livraison du courrier électronique sur le serveur (SMTP).',
  'dataroom.errDispatchStatus': 'Envoi terminé avec statut "{status}".',
};
